import { makeAutoObservable, runInAction } from 'mobx';
import partnerDashboardService from '../services/partnerDashboardService';
import partnerService from '../services/partnerService';

class PartnerDashboardStore {
  // Dashboard statistics
  stats = {
    inventory_count: 0,
    active_services: 0,
    pending_appointments: 0,
    pending_orders: 0,
    monthly_revenue: '0.00',
    recent_appointments: [],
    recent_orders: []
  };

  // Partner profile (company info)
  profile = null;
  profileLoading = false;

  loading = false;
  error = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  async fetchStats() {
    this.loading = true;
    this.error = null;

    try {
      const result = await partnerDashboardService.getStats();

      runInAction(() => {
        if (result.success) {
          this.stats = result.data;
        } else {
          this.error = result.error || 'Failed to fetch dashboard stats';
        }
        this.loading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error.message || 'Failed to fetch dashboard stats';
        this.loading = false;
      });
      return { success: false, error: this.error };
    }
  }

  async fetchProfile() {
    this.profileLoading = true;

    try {
      const result = await partnerService.fetchMyProfile();

      runInAction(() => {
        if (result.success) {
          this.profile = result.data;
        }
        this.profileLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.profileLoading = false;
      });
      return { success: false, error: error.message };
    }
  }

  // Reset store
  reset() {
    this.stats = {
      inventory_count: 0,
      active_services: 0,
      pending_appointments: 0,
      pending_orders: 0,
      monthly_revenue: '0.00',
      recent_appointments: [],
      recent_orders: []
    };
    this.profile = null;
    this.profileLoading = false;
    this.loading = false;
    this.error = null;
  }
}

export default PartnerDashboardStore;
